export default "__VITE_ASSET__B5kPAXN3__"